const copyText = async (text: string) => navigator.clipboard.writeText(text);

export default copyText;
